/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import posthog from "posthog-js";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.POSTHOG_ENABLED) {
  posthog.init(
    environment.POSTHOG_KEY,
    {
      api_host: environment.POSTHOG_HOST,
      person_profiles: "identified_only",
      autocapture: true,
    },
  );
}

// console.log('🚀 Starting app bootstrap...');
// console.log('Environment:', environment);

bootstrapApplication(AppComponent, appConfig)
  .then(() => console.log("✅ App bootstrapped successfully"))
  .catch((err) => {
    console.error("❌ Bootstrap failed:", err);
    console.error(err);
  });
